import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrHousekeepingEventSource.ts
var t = () => e("housekeepingEventSource");
//#endregion
export { t as useTrHousekeepingEventSource };
